// i18next 초기화입니다. src/index.js 에서 한 번만 import 합니다.
//
// 언어 판별은 utils/lang.js 의 isKorean 을 그대로 씁니다. 판별 규칙을 여기서
// 다시 구현하면 내비게이션(과거 pickLabel 방식)과 본문이 서로 다른 언어로
// 갈릴 수 있으므로, 기준은 한 곳에만 둡니다.
//
// 번역문은 src/locales/{ko,en}.json 에 모여 있습니다. 화면에서는
// useTranslation 의 t('키') 로 꺼내 씁니다.

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ko from '../locales/ko.json';
import en from '../locales/en.json';
import { isKorean } from '../utils/lang';

const lng = isKorean() ? 'ko' : 'en';

i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: ko },
    en: { translation: en }
  },
  lng,
  // 영문 번역이 비어 있으면 한국어가 대신 나옵니다. 제품이 한국어 기준입니다.
  fallbackLng: 'ko',
  interpolation: {
    // React 가 이미 이스케이프하므로 i18next 쪽은 끕니다.
    escapeValue: false
  },
  // 키가 없을 때 null 대신 키 문자열이 나오게 해서 누락을 화면에서 바로
  // 알아볼 수 있게 합니다.
  returnNull: false,
  react: {
    // 줄바꿈(<br/>)이나 <strong>, <code> 가 섞인 문구는 Trans 컴포넌트로
    // 처리합니다. 여기 등록된 태그는 components 를 넘기지 않아도 실제 요소로
    // 렌더되므로, 가이드 본문처럼 마크업이 섞인 문장을 한 덩어리로 번역할 수
    // 있습니다.
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'i', 'p', 'code', 'em']
  }
});

// 스크린리더와 브라우저 번역 기능이 참고하도록 문서 언어도 맞춰 둡니다.
if (typeof document !== 'undefined') {
  document.documentElement.setAttribute('lang', lng);
}

export default i18n;
